import React from 'react'
import { Routes, Route } from 'react-router-dom'

import NavBar from '../../components/NavBar/MyBiyesadi'

import Dashboard from './Dashboard/Index'
import MyProfile from './MyProfile/Index'
import PersonalInterest from '../MyBiye/MyProfile/PersonalInterest/Index'
import MyPhoto from './MyPhoto/Index'
import PartnerPreference from './PartnerPreference/Index'
import Settings from './Settings/Index'
import ContactDetails from './ContactDetails/Index'
import Package from './Package/Index'
import PaymentLog from './PaymentLog/Index'
// import FourOFour from '../FourOfour/Index'

const Master = () => {
    return (
        <>
            <NavBar />
            <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="profile" element={<MyProfile />} />
                <Route path="profile/personal-interest" element={<PersonalInterest />} />
                <Route path="photos" element={<MyPhoto />} />
                <Route path="partner-preference" element={<PartnerPreference />} />
                <Route path="settings" element={<Settings />} />
                <Route path="contact" element={<ContactDetails />} />
                <Route path="package" element={<Package />} />
                <Route path="paymentlog" element={<PaymentLog />} /> 
                {/* <Route path="*" element={<FourOFour />} /> */}
            </Routes>
        </>
    );
};

export default Master;